export default __webpack_public_path__ + "static/ape2x-cf93b1292ef750ee7fc2f2a96edc1e1b.png";